import { SingleSelectCards } from '../../../components/quiz';
import type { SelectableCardOption } from '../../../types';

interface AgeStepProps {
  ageGroup: string;
  onChange: (ageGroup: string) => void;
}

const AGE_OPTIONS: SelectableCardOption[] = [
  { id: '18-24', title: '18-24' },
  { id: '25-34', title: '25-34' },
  { id: '35-44', title: '35-44' },
  { id: '45-54', title: '45-54' },
  { id: '55-64', title: '55-64' },
  { id: '65+', title: '65+' },
];

export default function AgeStep({ ageGroup, onChange }: AgeStepProps) {
  return (
    <div className="quiz-step">
      <div className="quiz-step__header">
        <h2 className="quiz-step__question">What stage of life are you in?</h2>
        <p className="quiz-step__helper">So we can tailor recommendations to what matters now</p>
      </div>

      <div className="quiz-step__body">
        <SingleSelectCards
          options={AGE_OPTIONS}
          value={ageGroup}
          onChange={onChange}
          className="wide-select-grid"
        />
      </div>
    </div>
  );
}
